import type { Money } from "@core/index";
import { format } from "@core/index";
import { useBrand } from "@branding/useBrand";

/**
 * Renders a monetary amount at the display edge — the only place money becomes
 * a formatted string. Grouping/locale come from the active brand; negatives get
 * the `.neg` accounting style.
 */
export function MoneyText({
  value,
  className = "",
  parenNegative = true,
  colorSign = false,
}: {
  value: Money;
  className?: string;
  parenNegative?: boolean;
  colorSign?: boolean;
}) {
  const brand = useBrand();
  const sign = colorSign ? (value.amount < 0 ? " neg" : value.amount > 0 ? " pos" : "") : "";
  return (
    <span className={`num${sign}${className ? ` ${className}` : ""}`}>
      {format(value, brand.locale, { parenNegative })}
    </span>
  );
}
